import React, { useState, useEffect, useCallback } from "react";
import toast from "react-hot-toast";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import PageHeader from "@core/components/pageHeader";
import LibraryBookList from "views/pages/librarybook/LibraryBookList";
import AddLibraryBook from "views/pages/librarybook/AddLibraryBook";
import APICall from "network/APICall";
import EndPoints from "network/Endpoints";
import { useLocation } from "react-router-dom";
import Utility from "@core/helper/utility";
import { useSelector } from "react-redux";
import Loader from "@core/helper/Loader";

const LibraryBook = () => {
  const [openModal, setOpenModal] = useState(false);
  const [type, setType] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [libraryBookList, setLibraryBookList] = useState([]);
  const [libraryCateList, setLibraryCateList] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [updateData, setUpdateData] = useState(null);
  const [totalRecord, setTotalRecord] = useState(0);
  const [isFilter, setIsFilter] = useState(false);
  const [categoryId, setCategoryId] = useState(null);
  const [permission, setPermission] = useState({});
  const { userData } = useSelector((state) => state.auth);
  const [role, setRole] = useState("");
  const location = useLocation();

  const handleDeleteModal = (id) => {
    if (id) {
      const payload = { id };
      APICall("delete", payload, EndPoints.deleteLibraryBook)
        .then((response) => {
          const { isError, message } = response.data;
          if (response.status === 200 && !isError) {
            toast.success(message);
            const filter = libraryBookList.filter((o) => o.id !== id);
            setLibraryBookList(filter);
            fetchLibraryBooks(categoryId);
          }
        })
        .catch((error) => {
          return error;
        });
    }
    setDeleteOpen(!deleteOpen);
  };

  const handleOpen = (type, id) => {
    setOpenModal(!openModal);
    setSearchText("");
    setType(type);
    if (id) {
      const findList = libraryBookList.find((o) => o.id === id);
      setUpdateData(findList);
    }
  };

  useEffect(() => {
    fetchLibraryCategory();
  }, []);

  const fetchLibraryBooks = useCallback(
    (id) => {
      Loader.isLoading(true);
      const payload = {
        pageNo: pageNumber + 1,
        limit: pageSize,
        orderBy: "ASC",
        searchText: searchText,
        cat_id: id ? id.toString() : "",
      };
      APICall("post", payload, EndPoints.getLibraryBook)
        .then((response) => {
          const { result, totalCount } = response.data.data;
          if (response.status === 200 && result) {
            setLibraryBookList(result);
            setTotalRecord(totalCount);
          } else {
            setLibraryBookList([]);
          }
        })
        .catch((error) => {
          return error;
        })
        .finally(() => {
          Loader.isLoading(false);
        });
    },
    [pageNumber, pageSize, searchText]
  );

  const fetchLibraryCategory = () => {
    const payload = {
      pageNo: 1,
      limit: 100,
      orderBy: "ASC",
      searchText: "",
    };
    APICall("post", payload, EndPoints.getLibraryCategory)
      .then((response) => {
        const { results } = response.data.data;
        if (response.status === 200 && results) {
          setLibraryCateList(results);
        } else {
          setLibraryCateList([]);
        }
      })
      .catch((error) => {
        return error;
      });
  };
  useEffect(() => {
    if (userData.data.user.role === "2") {
      const librarybook = Utility.getUserData({
        datastore: userData,
        activePath: location.pathname,
      });

      setPermission(librarybook[1]);
    } else {
      setPermission({});
    }

    setRole(userData.data.user.role);
  }, [location.pathname, userData]);
  useEffect(() => {
    fetchLibraryBooks(categoryId);
  }, [searchText, pageNumber, pageSize, fetchLibraryBooks, categoryId]);
  const fetchCategoryFilter = (id) => {
    setCategoryId(id.toString());
    setPageNumber(0);
    fetchLibraryBooks(id);
  };

  const removeFilter = () => {
    setCategoryId(null);
    setIsFilter(false);
    setPageNumber(0);
    fetchLibraryBooks(null);
  };

  const submitLibraryBooks = () => {
    fetchLibraryBooks(categoryId);
  };

  return (
    <Grid container spacing={4}>
      <PageHeader
        title={
          <Typography variant="body1" sx={{ fontSize: "1.3rem !important" }}>
            Library Book Manage
          </Typography>
        }
      />
      {((permission.view && role === "2") || role === "1") && (
        <Grid item xs={12}>
          <LibraryBookList
            handleDeleteModal={handleDeleteModal}
            deleteOpen={deleteOpen}
            handleOpen={handleOpen}
            libraryBookList={libraryBookList}
            pageSize={pageSize}
            setPageSize={setPageSize}
            searchText={searchText}
            setSearchText={setSearchText}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            totalRecord={totalRecord}
            libraryCateList={libraryCateList}
            fetchCategoryFilter={fetchCategoryFilter}
            isFilter={isFilter}
            removeFilter={removeFilter}
            setIsFilter={setIsFilter}
            permission={permission}
            role={role}
          />
        </Grid>
      )}
      <AddLibraryBook
        open={openModal}
        toggle={handleOpen}
        type={type}
        heading={type === "edit" ? "Update Library Books" : "Add Library Books"}
        onSubmitBooks={submitLibraryBooks}
        libraryCateList={libraryCateList}
        updateData={updateData}
        permission={permission}
        role={role}
      />
    </Grid>
  );
};

export default LibraryBook;
